<template>
  <div class="teaser-mini" @click="openTeaserTarget">
    <template v-if="item.illustration">
      <div class="illustration">
        <img class="illustration-img" :src="item.illustration" alt="" />
      </div>
    </template>
    <div class="text-content">
      <dotcom-icon
        name="arrow-right-long"
        art="regular"
        color="--c-primary-neutral-1"
      />
      <h3>{{ item.title }}</h3>
      <div class="description">
        {{ item.description }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WizardTeaserMini',
  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    openTeaserTarget() {
      const { item } = this
      if (item.linkTarget === '_self') {
        window.document.location.href = item.linkPath
      } else if (item.linkTarget === '_blank') {
        window.open(item.linkPath, '_blank')
      }
      this.$emit('cardClicked')
    },
  },
}
</script>

<style scoped>
.teaser-mini {
  display: flex;

  * {
    box-sizing: border-box;
  }

  font-weight: 400;
  font-style: normal;
  font-size: 15px;
  line-height: 1.35;
  color: var(--c-primary-neutral-1);
  background-color: var(--c-primary-neutral-3);
  border: 1px solid var(--c-secondary-neutral-3);
  border-radius: 8px;
  padding: 10px;

  .illustration {
    margin-right: 20px;
    line-height: 1px;

    &-img {
      border-radius: 50%;
      max-width: 80px;
    }

    @media (max-width: 544px) {
      display: none;
    }
  }

  .text-content {
    flex-grow: 1;
    width: 100%;

    & >>> .dotcom-icon {
      float: right;
      position: relative;
      font-size: 12px;
    }

    h3 {
      font-family: 'TheMix Bold', sans-serif;
      font-weight: 700;
      font-style: normal;
      font-size: 18px;
      line-height: 1.25;
      color: var(--c-primary-color-2);
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      text-transform: none;
      padding-bottom: 2px;

      @media (--md) {
        padding-bottom: 5px;
      }
    }
  }
}
</style>
